import React from 'react';
import { FormattedMessage } from 'react-intl';

const NoAssistanceResults = () => (
  <div data-testid="no-assistance-results">
    <p>
      <FormattedMessage id="addAssistance.noResults" data-testid="addAssistance.noResults" />
    </p>
  </div>
);

export default NoAssistanceResults;
